import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabela-skeleton',
  standalone: true,
  imports: [],
  templateUrl: './tabela-skeleton.component.html',
  styleUrl: './tabela-skeleton.component.css'
})
export class TabelaSkeletonComponent implements OnInit {

  @Input()
  qntdLinhas = 5;

  linhas: number[] = [];

  ngOnInit(): void {
    this.verificarQuantidadeLinhas();
  }

  verificarQuantidadeLinhas(){
    for(let i = 0; i < this.qntdLinhas; i++) {
      this.linhas.push(i + 1);
    }
  }

}
